import { useEffect, useMemo, useRef, useState } from 'react';

import { Menu, MenuItem } from '../Menus';
import MenuItemStyles from '../Menus/MenuItem/MenuItem.module.scss';

import styles from './RawDropdown.module.scss';
import { RawDropdownProps } from './RawDropdown.types';

export const RawDropdown = <T,>({
  placeholder,
  canBeReset,
  items,
  keyValueExtractor,
  onSelectItem,
  selectedItem,
  onOpen,
  onClose,
  ...props
}: RawDropdownProps<T>) => {
  const ref = useRef<HTMLDivElement>(null);

  const selectedKey = useMemo(
    () => selectedItem && keyValueExtractor(selectedItem).key,
    [keyValueExtractor, selectedItem]
  );

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const selected = ref.current?.getElementsByClassName(MenuItemStyles.focus)?.[0];
        selected?.scrollIntoView({ block: 'center' });
      });
    }
  }, [isOpen]);

  return (
    <Menu
      onOpen={() => {
        setIsOpen(true);
        onOpen?.();
      }}
      onClose={() => {
        setIsOpen(false);
        onClose?.();
      }}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      {...props}
    >
      <div className={styles.items} ref={ref}>
        {canBeReset && (
          <MenuItem selected={selectedKey === undefined} onClick={() => onSelectItem(undefined)}>
            {placeholder}
          </MenuItem>
        )}
        {items.map(item => {
          const { key, value, icon } = keyValueExtractor(item);
          return (
            <MenuItem key={key} selected={selectedKey === key} onClick={() => onSelectItem(item)}>
              {icon}
              {value}
            </MenuItem>
          );
        })}
      </div>
    </Menu>
  );
};
